import { render, staticRenderFns } from "./parking-charge-rule.vue?vue&type=template&id=b0cbca9e"
import script from "./parking-charge-rule.vue?vue&type=script&lang=js"
export * from "./parking-charge-rule.vue?vue&type=script&lang=js"
import style0 from "./parking-charge-rule.vue?vue&type=style&index=0&id=b0cbca9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports